import { create } from 'zustand'

export interface LastTransactionParams {
  transactionId: string
  paymentUrl?: string // For hosted page redirect
  paymentSessionToken?: string // For Checkout.com Flow SDK
  paymentSessionSecret?: string // For Checkout.com Flow SDK
}

interface TransactionState {
  lastTransactionData: LastTransactionParams | null
}

interface TransactionActions {
  setLastTransactionData: (data: LastTransactionParams) => void
  clearLastTransactionData: () => void
}

export const useTransactionStore = create<
  TransactionState & TransactionActions
>((set) => ({
  lastTransactionData: null,

  setLastTransactionData: (data) => set({ lastTransactionData: data }),

  clearLastTransactionData: () => set({ lastTransactionData: null }),
}))
